import { FaFileSignature, FaComments, FaCalendarAlt } from "react-icons/fa";

export const services = [
  {
    icon: <FaFileSignature />,
    title: "Firma Electrónica Avanzada",
    description:
      "Garantice la autenticidad y seguridad de sus documentos con nuestra firma electrónica avanzada.",
  },
  {
    icon: <FaComments />,
    title: "Chat en Tiempo Real",
    description: "Comunique y colabore de manera instantánea con nuestros servicios de chat en tiempo real.",
  },
  {
    icon: <FaCalendarAlt />,
    title: "Integración con Google Calendar y Meet",
    description:
      "Agende reuniones fácilmente y conéctese con sus clientes a través de Google Calendar y Google Meet.",
  },
];
